import React from 'react';
import { Label } from 'reactstrap';
import { compose, withHandlers } from 'recompose';
import { ModalHeader, ModalBody, ModalFooter } from '../../modal-helpers';
import Button from '../../../buttons/DeprecatedButton/DeprecatedButton';
import './CustomAudienceErrorModal.scss';

type Props = {
  error?: string | string[];
  onModalSubmit: () => void;
};

const onModalSubmit =
  ({ closeModal }) =>
  () => {
    closeModal();
  };

const enhance = compose<Props, Props>(withHandlers({ onModalSubmit }));

const CustomAudienceErrorModal = (props: Props) => {
  const { error, onModalSubmit } = props;

  const errorWithoutDot = (
    (Array.isArray(error) ? error[0] : error) || ''
  ).replace(/\.$/, '');
  return (
    <div className="ad-audience-error-modal">
      <ModalHeader className="ad-audience-error-modal__header">
        Audience wasn't synced
      </ModalHeader>
      <ModalBody className="ad-audience-error-modal__body">
        <Label className="ad-audience-error-modal__input-wrapper">
          <div className="ad-audience-error-modal__input-with-error">
            <p>{errorWithoutDot}</p>
          </div>
        </Label>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onModalSubmit}>OK</Button>
      </ModalFooter>
    </div>
  );
};

export default enhance(CustomAudienceErrorModal);
